import { render, staticRenderFns } from "./AttachmentsComponent.vue?vue&type=template&id=c5c4f1c0&scoped=true"
import script from "./AttachmentsComponent.vue?vue&type=script&lang=js"
export * from "./AttachmentsComponent.vue?vue&type=script&lang=js"
import style0 from "./AttachmentsComponent.vue?vue&type=style&index=0&id=c5c4f1c0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5c4f1c0",
  null
  
)

export default component.exports